
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 1.73a7.374 7.374 0 01-2.12.581A3.708 3.708 0 0017.503.27a7.444 7.444 0 01-2.347.896 3.693 3.693 0 00-6.292 3.367A10.483 10.483 0 011.254.675a3.664 3.664 0 00-.5 1.856 3.69 3.69 0 001.643 3.073A3.693 3.693 0 01.724 5.14v.046a3.696 3.696 0 002.962 3.621 3.74 3.74 0 01-.973.13c-.238 0-.47-.024-.695-.07a3.694 3.694 0 003.448 2.565A7.408 7.408 0 01.881 13.01c-.298 0-.592-.018-.881-.05a10.438 10.438 0 005.66 1.661c6.793 0 10.505-5.626 10.505-10.505l-.012-.478A7.374 7.374 0 0018 1.73z"}})])
          )
        }
      }
    